var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.55,
    viewBox: "0 0 16 14.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Folder",
    d: "M4.2,4.5a.7.7,0,0,0-.7.7V8.075h13v-.7a.7.7,0,0,0-.7-.7H9.275a.75.75,0,0,1-.624-.334L7.424,4.5ZM16.5,9.575H3.5V15.35a.7.7,0,0,0,.7.7H15.8a.7.7,0,0,0,.7-.7ZM2.644,3.644A2.2,2.2,0,0,1,4.2,3H7.825a.75.75,0,0,1,.624.334L9.676,5.175H15.8a2.2,2.2,0,0,1,2.2,2.2V15.35a2.2,2.2,0,0,1-2.2,2.2H4.2A2.2,2.2,0,0,1,2,15.35V5.2A2.2,2.2,0,0,1,2.644,3.644Z",
    transform: "translate(-2 -3)",
    fill: "#373737",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.59fd7dae9e37deb6b49d746ae4542ba6.svg";
export { ForwardRef as ReactComponent };